(function() {

    function mouseTarget(e) {
        let targ;
        if (!e) var e = window.event;
        if (e.target) targ = e.target;
        else if (e.srcElement) targ = e.srcElement;
        if (targ.nodeType == 3) // defeat Safari bug
            targ = targ.parentNode;
        return targ;
    }

    function mousePositionDocument(e) {
        let posX = 0;
        let posY = 0;
        if (!e) {
            const e = window.event;
        }
        if (e.pageX || e.pageY) {
            posX = e.pageX;
            posY = e.pageY;
        }
        else if (e.clientX || e.clientY) {
            posX = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            posY = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        return {
            x : posX,
            y : posY
        };
    }

    function mousePositionElement(e, className) {
        const mousePosDoc = mousePositionDocument(e);
        const target = mouseTarget(e);
        const targetPos = target.getBoundingClientRect();
        let posX;
        let posY;
        if(target.classList.contains(className)) {
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            posX = (mousePosDoc.x - (targetPos.x + scrollLeft));
            posY = (mousePosDoc.y - (targetPos.y + scrollTop));
            target.style.background = `radial-gradient(circle 300px at ${posX}px ${posY}px, #9999ff, #66ccff)`;
        }
    }

    let moveEffect = (event) => {
        mousePositionElement(event, 'btn--gradient');
        //console.log('CHAMOU gradient')
    };

    document.addEventListener('mousemove', moveEffect);

})();